// extracted by mini-css-extract-plugin
module.exports = {"leftColumn":"instructorsProfile_leftColumn__29_Cx","tableTitle":"instructorsProfile_tableTitle__3e1-D","rightColumn":"instructorsProfile_rightColumn__U5UtX"};